<template>
    <div>
        <!-- 实例 -->
        <div class="instances">
            <Row :gutter="10">
                <Col span="4">
                    <Button type="primary" @click="addModal()">{{ $t('smartMonitor.applicationSystem.addInstance') }}</Button>
                </Col>
            </Row>
        </div>
        <Modal v-model="modal" :title="$t('smartMonitor.applicationSystem.addInstance')" width="900px;" :loading="modalLoading" :ok-text="$t('MCM.automaticalMaintenanceReport.add')" :mask-closable="false" :closable="false">
            <Form :model="resourceForm" :label-width="40" ref="resourceForm">
                <!-- 搜索 -->
                <Row :gutter="16">
                    <Col span="8">
                        <!-- 账户 -->
                        <FormItem :label="$t('smartMonitor.applicationSystem.account')" prop="account">
                            <Select v-model="resourceForm.account" :placeholder="$t('resourceLifecycle.pleaseSelect')"
                                @on-change="changeAccount(resourceForm.account)" :transfer="true">
                                <Option :value="item.id" @click.native="getMoreParams(item)" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="8" v-if="platformType!=3">
                        <!-- 存储区域 -->
                        <FormItem :label="$t('smartMonitor.applicationSystem.region')" prop="region">
                            <Select @on-change="changeRegion(resourceForm.region)"
                                v-model="resourceForm.region" :transfer="true" multiple :max-tag-count="1" :placeholder="$t('resourceLifecycle.pleaseSelect')">
                                <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('configuration_management.customized_alarm_config.checkAll') }}</Checkbox>
                                <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <!-- 标签 -->
                        <FormItem :label="$t('alarms.common.tags')" prop="tags">
                            <Input v-model="resourceForm.tags" placeholder=""/>
                        </FormItem>
                    </Col>
                    <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchInstancesInput()">{{ $t('alarms.common.search') }}</Button>
                </Row>
            </Form>
            <div slot="footer">
                <Button @click="cancel('resourceForm')">{{ $t('RIAccountGroupManagement.cancel') }}</Button>
                <Button type="primary" @click="handleSubmit('resourceForm')" :loading="addloading" :disabled="isDisable">{{ $t('MCM.automaticalMaintenanceReport.add') }}</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns4" :loading="loading" :data="queryAccountInstancesData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
        <table-instances></table-instances>
    </div>
</template>

<script>
    import TableInstances from '../ec2/TableInstances'

    var tableInstances = TableInstances;
    export default {
        name: 'AddInstances',
        components: {
            TableInstances
        },
        data() {
            return {
                singleBackupRegion:false,
                platformType:'',
                selection: [],
                modal: false,
                modalLoading: true,
                loading: false,
                addloading:false,
                isDisable: true,
                accountList: [],
                regionList: [],
                isShowSearch: false,
                resourceForm: {
                    account: '',
                    region: [],
                    tags: ''
                },
                columns4: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('instance_list.instanceName'),
                        key: 'name',
                    },
                    {
                        title: this.$t('RAM.AWS.computeInstance.instanceID'),
                        key: 'instanceId'
                    },
                    {
                        title: this.$t('instance_list.privateIP'),
                        key: 'privateIp'
                    },
                    {
                        title: this.$t('alarms.common.status'),
                        key: 'stateName'
                    }
                ],
                queryAccountInstancesData: [],
                newQueryAccountInstancesDataList:[]
            }
        },
        methods: {
            addModal:function(){
                this.modal=true;
                // 查询账户
                this.$api.account.selectAccountByCloudPlatform("type", this.$route.query.type)
                .then(res => {
                    this.accountList = res.data;
                })
            },
            // 切换账户
            changeAccount: function () {
                if (this.resourceForm.account == "" || this.resourceForm.account == null) {
                    return;
                }
                this.resourceForm.region = [];
                this.isShowSearch = true;
                this.$api.account.queryAccountRegions("accountId", this.resourceForm.account)
                    .then(res => {
                        this.regionList = res.data;
                    })
            },
             //获取自己要的属性
            getMoreParams:function(params){
                //账号类型
                this.platformType=params.type;
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.resourceForm.region = []
                if (this.singleBackupRegion) {
                    this.regionList.map((item) => {
                        this.resourceForm.region.push(item.name)
                    })
                } else {
                    this.resourceForm.region = []
                }
            },
            // 切换存储区域
            changeRegion: function (val) {
                 if (val.length === this.regionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                this.instanceList = [];
                this.isShowSearch = true;
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryAccountInstancesDataList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableQueryAccountInstancesDataCopy = new Object();
                    TableQueryAccountInstancesDataCopy.ticketCompanyMonitorItemVariablesId = this.$route.query.id;
                    TableQueryAccountInstancesDataCopy.resourceId = this.selection[i].id;
                    TableQueryAccountInstancesDataCopy.resourceType = this.$route.query.monitorModule;
                    this.newQueryAccountInstancesDataList.push(TableQueryAccountInstancesDataCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryAccountInstancesDataList.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 点击查询
            searchInstancesInput: function () {
                if (this.resourceForm.account == "" || this.resourceForm.account == null) {
                    return;
                }
                this.loading = true;
                // 根据AccountId查询Instance列表
                this.$api.alertRuleExceptionResource.listNotExceptionResource({
                    "regions": this.resourceForm.region,
                    "accountId": this.resourceForm.account,
                    "monitorModule": this.$route.query.monitorModule,
                    "ticketCompanyMonitorItemVariablesId": this.$route.query.id
                }).then(res => {
                    this.queryAccountInstancesData = res.data;
                    this.loading = false;

                })
            },
            // 添加
            handleSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 增加instance
                        this.addloading=true;
                        this.$api.alertRuleExceptionResource.batchCreate({
                            "alertRuleExceptionResourceDTOS":this.newQueryAccountInstancesDataList
                        }).then(res => {
                            setTimeout(() => {
                                tableInstances.methods.showAllInstance();
                                this.$refs[name].resetFields();
                                this.modalLoading = false;
                                this.$nextTick(() => {
                                    this.modalLoading = true;
                                });
                                this.$Message.success('添加成功');
                                this.queryAccountInstancesData=[];
                                this.newQueryAccountInstancesDataList=[];
                                this.modal = false;
                                this.addloading=false;
                                this.isDisable = true;
                                this.isShowSearch=false;
                            }, 1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.modalLoading = false;
                        setTimeout(() => {
                            this.modalLoading = true
                        }, 0)
                        this.$Message.error('添加失败');
                    }
                });
                    
            },
             // 取消
            cancel: function (name) {
                this.isDisable = true;
                this.modal = false;
                this.isShowSearch=false;
                this.queryAccountInstancesData=[];
                this.newQueryAccountInstancesDataList=[];
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>
  .instances {
    width: 100%;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/ec2/AddInstances.vue